<template>
  <div v-if="whatsapp || payment" class="links">
    <a v-if="whatsapp" :href="whatsapp" class="links__item links__item--whatsapp" target="_blank" rel="noopener">JOIN WHATSAPP GROUP</a>
    <a v-if="payment" :href="payment" class="links__item links__item--pay" target="_blank" rel="noopener">PAY ONLINE</a>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "Links",
    computed: {
      ...mapState({
        whatsapp: (state) => state.info.whatsapp,
        payment: (state) => state.info.payment
      })
    }
  };
</script>

<style scoped>
  .links {
    display: grid;
    /* Side by side when both fit, stacked on a narrow phone. */
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 10px;
  }

  .links__item {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 0 14px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-align: center;
    box-shadow: var(--tb-shadow);
  }

  .links__item--whatsapp {
    background: #e4f7e8;
    color: #1d7a41;
  }

  .links__item--pay {
    background: #e6f3ff;
    color: #10538c;
  }
</style>
